import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideDirective } from 'app/directives/click-outside.directive';
import { CustomSanitizeHtmlPipe } from 'app/pipes/custom-sanitize-html.pipe';

@Component({
  selector: 'sma-web-feedback',
  template: `
    @if (!hideFeedback) {
      <div class="feedback-container" (click)="toggle()" (smaWebClickOutside)="close()">
        <div class="feedback-form" [class.active]="active">
          <h1>{{ 'FEEDBACK.TITLE' | translate }}</h1>
          <div [innerHTML]="'FEEDBACK.TEXT' | translate | customSanitizeHtml"></div>
          <a [href]="feedbackMailTo" class="fwe-btn fwe-float-right fwe-mt-5">
            <i class="fwe-icon fwe-icon-communication-message"></i> {{ 'FEEDBACK.BUTTON_SEND' | translate }}
          </a>
        </div>
        <button
          type="button"
          class="fwe-btn fwe-btn-hero fwe-btn-icon"
          [class.inactive]="active"
          [class.active]="active"
          [class.fwe-color-hero]="active"
          >
          <i class="fwe-icon fwe-icon-communication-communication"></i>
        </button>
      </div>
    }
    `,
  styleUrls: ['feedback.component.scss'],
  imports: [TranslateModule, ClickOutsideDirective, CustomSanitizeHtmlPipe],
})
export class FeedbackComponent {
  @Input() hideFeedback = false;
  @Input() appName: string | null = null;
  @Input() contactMailAddress: string | null = null;

  active: boolean;

  get feedbackMailTo(): string {
    return `mailto:${this.contactMailAddress}?subject=${encodeURI(this.appName || '')}%20Feedback`;
  }

  toggle(): void {
    this.active = !this.active;
  }

  close(): void {
    this.active = false;
  }
}
